import { Injectable, OnInit } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class BaseMapService implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
